const getJsonnetData = (baseUrl, brand, region, country, language) => {
    const jsonURL = `${baseUrl}/${brand}-${region}-${country}-${language}`;
    return fetch(`${jsonURL}.json`);
};
export default getJsonnetData;
//# sourceMappingURL=getJsonnetData.js.map